import { mediaQuery, typeStyle } from '@carvana/showroom-css-theme';
import React from 'react';
import styled from 'styled-components';
import useConfig from '../hooks/useConfig';
import { HeaderConfig } from '../headerConfig';
import { Logo } from './icons';
import NavItem from './NavItem';
import MobileMenu from './MobileMenu';
import SigninButton from './SigninButton';

const HeaderContainer = styled.header`
  background: var(--cvna-color-white);
  padding: 20px 24px 19px 24px;
  display: flex;
  align-items: center;
  filter: drop-shadow(var(--cvna-elevation-1));
`;



const LogoContainer = styled.a`
  display: flex;
  flex-grow: 1;
  ${mediaQuery('l')} {
    flex-grow: 0;
  }
`;

const NavContainer = styled.nav`
  display: none;
  ${mediaQuery('l')} {
    display: flex;
    flex-grow: 1;
    align-items: center;
    margin-left: 4rem;
    gap: 2rem;
  }
`;

const MenuContainer = styled.div`
  display: none;
  ${mediaQuery('l')} {
    display: flex;
    align-items: center;
    padding-bottom: 4px;
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 16px;
  background: var(--cvna-color-grey-2);
`;



const SupportContactLink = styled.a`
  ${typeStyle('label-m')};
  margin: 0;
  color: var(--cvna-color-blue-6);
  transition: color 150ms ease-in-out;
  :hover {
    text-decoration: none;
    color: var(--cvna-color-blue-2);
  }
`;

const MobileSignInContainer = styled.div`
  ${mediaQuery('l')} {
    display: none;
  }
`;

const defaultProps = {
  config: {}
};

type HeaderProps = {
  config?: HeaderConfig;
} & typeof defaultProps;

type AuthProps =  | { useAuth?: false; onSignin?(): never }
| { useAuth: true; onSignin(): void }

type Props = HeaderProps & AuthProps;

const Header = ({ useAuth, config, onSignin }: Props) => {
  const headerConfig = useConfig(config);


  return (
    <HeaderContainer>
      <MobileMenu onSignin={onSignin} useAuth={useAuth} config={headerConfig} />
      <LogoContainer href={headerConfig.home?.url}>
        <Logo />
      </LogoContainer>
      <NavContainer>
        {headerConfig.navigation?.map(({ label, url, childItems }) => (
          <NavItem
            key={label}
            label={label}
            href={url}
            childItems={childItems}
          />
        ))}
      </NavContainer>
      <MenuContainer>
        {headerConfig.supportContact?.display && (
          <SupportContactLink href={headerConfig.supportContact.url}>
            Support &amp; Contact
          </SupportContactLink>
        )}
        {useAuth && (
          <>
            <Divider />
            <SigninButton onSignin={onSignin}/>
          </>
        )}
      </MenuContainer>
      {useAuth && (
        <MobileSignInContainer>
          <SigninButton onSignin={onSignin}/>
        </MobileSignInContainer>
      )}
    </HeaderContainer>
  );
};

Header.defaultProps = defaultProps;

export default Header;
